import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyAAChrTspwQZmpHM702XdWQWqc2L9fBX3U",
  authDomain: "notificationtest-c5865.firebaseapp.com",
  projectId: "notificationtest-c5865",
  storageBucket: "notificationtest-c5865.firebasestorage.app",
  messagingSenderId: "453776778144",
  appId: "1:453776778144:web:8421559da0de9636e07ac5"
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
